import React, { useEffect, useState } from "react";
import logo from "../assets/Logo.svg";
import { IoMenu } from "react-icons/io5";

const sections = [
  { name: "home", link: "#", label: "الرئيسية" },
  { name: "sections", link: "#sections", label: "الاقسام" },
  { name: "offers", link: "#offers", label: "عروض سلامات" },
  { name: "features", link: "#features", label: "ميزات المنصة" },
  { name: "overview", link: "#overview", label: "لمحة عنا" },
];

const NavBar = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    if (windowWidth >= 768) setisOpen(false);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  const [isOpen, setisOpen] = useState(false);
  const [section, setSection] = useState({
    home: true,
    sections: false,
    courses: false,
    overview: false,
    instructors: false,
  });

  const handleChangeSection = (name) => {
    for (const [key, value] of Object.entries(section)) {
      if (key !== name) setSection((prev) => ({ ...prev, [key]: false }));
      else setSection((prev) => ({ ...prev, [key]: true }));
    }
  };

  return (
    <div className="flex w-full items-center justify-center" dir="rtl">
      <nav className="flex  justify-between items-center p-5 flex-wrap w-[90%] ">
        <div className=" flex justify-center items-center">
          <div
            className={`bg-white absolute -top-24 -left-20 rounded-3xl  z-[-1] w-[400px] h-[300px] max-lg:w-[300px] max-md:w-[250px] max-lg:h-[250px] max-md:h-[200px]`}
          />
          <div className="max-lg:w-[160px] max-lg:h-[80px] max-md:w-[130px] max-md:h-[100]">
            <a href="/">
              <img src={logo} alt="hello" className="w-full h-full" />
            </a>
          </div>
        </div>
        <ul className="flex items-center max-md:hidden">
          {sections.map((e) => (
            <li
              key={e.name}
              onClick={() => handleChangeSection(e.name)}
              className={`text-lg rounded-lg flex items-center justify-center p-2
              ${section[e.name]
                  ? "border-b-4 border-blue-200 text-[#00386C]"
                  : "text-[#303030]"}
               `}
            >
              <a
                href={e.link}
                className=" px-6 py-2 font-semibold max-lg:text-base max-lg:px-3 max-lg:py-1"
              >
                {e.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className="hidden md:flex bg-white border border-2 rounded-xl border-blue-300 text-blue-300 text-xl p-3"
          onClick={() => {
            const contactSection = document.getElementById("contact-us");
            contactSection?.scrollIntoView({ behavior: "smooth" });
          }}
        >
          تواصل معنا
        </button>
          
        <button
          onClick={() => setisOpen(!isOpen)}
          className="md:hidden flex justify-end"
        >
          <IoMenu size={30} color="#00488B" />
        </button>
        {isOpen && (
          <ul className="w-full space-y-1">
            {sections.map((e) => (
              <li
                onClick={() => handleChangeSection(e.name)}
                className={`${section[e.name]
                  ? "bg-gradient-to-tr from-[#00386C] to-[#001B34] text-white"
                  : "text-[#3E3E3E]"
                  } text-xl rounded-lg flex items-center justify-center text-center border-b-2 border-[#3E3E3E]`}
              >
                <a href={e.link} className="py-1 max-lg:text-lg w-full">
                  {e.label}
                </a>
              </li>
            ))}
            <li className="rounded-lg flex items-center justify-center text-center border-b-2 border-[#3E3E3E] py-1">

            </li>
          </ul>
        )}
      </nav>
    </div>
  );
};

export default NavBar;
